import React, { useMemo } from 'react';
import Select from '../../../form/Select';
import { useGetFacilityBulkAssignProfessionalsQuery } from '../../../../redux/bulkAssignShiftsApi';

const ENABLED_STATUS_CODE = 'ENABLED';

const getHighestRankedLicense = (resourceTypes) => {
	if (!Array.isArray(resourceTypes) || resourceTypes.length === 0) return null;
	const sorted = [...resourceTypes].sort((a, b) => (b.rank || 0) - (a.rank || 0));
	return sorted[0].code || null;
};

const formatLabel = (row) => {
	const license = getHighestRankedLicense(row.resource_types);
	return license ? `${row.name}, ${license}` : row.name;
};

const BulkAssignShiftsProfessionalInput = ({ facilityId, selectedCaregiver, onCaregiverChange, disabled }) => {
	const { data: workers = [], isFetching } = useGetFacilityBulkAssignProfessionalsQuery(
		{ facilityId },
		{ skip: !facilityId }
	);

	const options = useMemo(
		() =>
			workers
				.filter((item) => !item.is_disabled && item.is_active && item.worker_status === ENABLED_STATUS_CODE)
				.map((row) => ({
					label: formatLabel(row),
					value: row.id
				})),
		[workers]
	);

	const handleChange = (patch) => {
		const caregiverId = patch.bulkAssignProfessional;
		if (!caregiverId) {
			onCaregiverChange(null);
			return;
		}
		const row = workers.find((candidate) => candidate.id === caregiverId);
		onCaregiverChange({
			id: caregiverId,
			name: row?.name,
			displayLabel: row ? formatLabel(row) : null,
			licenseCodes: (row && row.resource_types ? row.resource_types : []).map((type) => type.code),
			specialtyCodes: (row && row.specialties ? row.specialties : []).map((spec) => spec.code)
		});
	};

	return (
		<Select
			name="bulkAssignProfessional"
			className="request-shifts-modal-select"
			placeholder="Select..."
			options={options}
			value={selectedCaregiver ? selectedCaregiver.id : null}
			handleChange={handleChange}
			isDisabled={disabled || !facilityId}
			isSearchable
			noOptionsMessage={isFetching ? 'Loading professionals…' : 'No professionals found'}
		/>
	);
};

export default BulkAssignShiftsProfessionalInput;
